document.addEventListener('DOMContentLoaded', function () {
  const menuToggler = document.querySelector('div.menu-toggler-fl');
  if (window.scrollY > 200) {
    menuToggler.classList.add('visible');
  }
  
  // Add a capturing phase event listener for the close button
  // This runs BEFORE any other listeners in the bubbling phase
  document.addEventListener('click', function(event) {
    const closeButton = event.target.closest('button.wp-block-navigation__responsive-container-close');
    if (closeButton) {
      event.preventDefault();
      event.stopImmediatePropagation(); // Stronger than stopPropagation
      
      const navMenu = document.querySelector('.wp-block-navigation__responsive-container');
      if (navMenu && navMenu.classList.contains('is-menu-open')) {
        navMenu.classList.remove('is-menu-open');
        document.documentElement.classList.remove('has-modal-open');
      }
    }
  }, true); // true enables capturing phase instead of bubbling
});

document.addEventListener('scroll', function () {
  const menuToggler = document.querySelector('div.menu-toggler-fl');
  if (window.scrollY > 200) {
    menuToggler.classList.add('visible');
  } else {
    menuToggler.classList.remove('visible');
  }
});

document.addEventListener('click', function (event) {
  if (event.target.closest('.menu-toggler-fl')) {
    const navMenu = document.querySelector('.wp-block-navigation__responsive-container');
    if (navMenu) {
      const isOpen = navMenu.classList.toggle('is-menu-open');
      document.documentElement.classList.toggle('has-modal-open', isOpen);
    }
  }
});